import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

export const StyledInputSuffixElement = styled(
  ({ $hasError = false, $isDisabled = false, $isFocused = false, children, ...other }) => cloneElement(children, other)
)`
  ${({ $hasError, $isDisabled, $isFocused, theme }) =>
    css`
      /* This is needed for IE */
      flex-shrink: 0;

      /* No other way to apply styling */
      svg {
        fill: ${theme.color.gray['600'].value};
        fill: ${$isFocused && theme.color.primary['500'].value};
        fill: ${$hasError && theme.color.system.negative['500'].value};
        fill: ${$isDisabled && theme.color.text.light.disabled.value};
        padding-right: ${theme.size.spacing.small.value};
      }

      &:hover,
      &:focus {
        /* No other way to apply styling */
        svg {
          fill: ${!$isDisabled && theme.color.primary['500'].value};
        }
      }
    `}
`;

const InputSuffixElement = ({ dataTestId, hasError = false, isDisabled = false, isFocused = false, ...other }) => (
  <StyledInputSuffixElement $hasError={hasError} $isDisabled={isDisabled} $isFocused={isFocused} {...other} />
);

InputSuffixElement.propTypes = {
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** If true, input is in error state */
  hasError: PropTypes.bool,
  /** If true, disables state appearances changes */
  isDisabled: PropTypes.bool,
  /** If true, applies primary color to suffix svg */
  isFocused: PropTypes.bool,
};

export { InputSuffixElement };
